/**
 * NEXUS UI - Main Application Entry
 */

import React from 'react';
import { NexusDemo } from './NexusDemo';

const App: React.FC = () => {
  return <NexusDemo />;
};

export default App;
